export enum AdminBoxQuestionnaireListItemAction {
  Resume,
  End,
  More,
  Preview,
}
